import React from 'react';

function ExternalLink({href, children, className = ''}) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      className={className}>
      {children}
    </a>
  );
}

export default function BookCard({book, coverSrc, size = 'small'}) {
  const isFeatured = size === 'featured';

  return (
    <div className={isFeatured ? 'p-3 displaybackground' : 'p-2 oldbackground'}>
      <img
        src={coverSrc}
        alt={`${book.title} cover`}
        className={
          isFeatured
            ? 'm-2 float-start img-fluid displaybookimage'
            : 'm-2 float-start oldbookimage'
        }
      />

      {isFeatured ? <h2>{book.title}</h2> : <h3>{book.title}</h3>}

      <section
        className={
          isFeatured ? 'displaybooktext p-2 p-sm-1' : 'oldbooktext p-2 p-sm-1'
        }>
        {book.tagline && <p>{book.tagline}</p>}
        {book.description?.map((p, idx) => (
          <p key={idx}>{p}</p>
        ))}

        {book.blurbs?.length ? (
          <>
            <div className='stars'>★★★★★</div>
            {book.blurbs.map((b, idx) => (
              <p key={idx}>
                <i>{b}</i>
              </p>
            ))}
          </>
        ) : null}

        {book.links?.length ? (
          <p
            className={
              isFeatured
                ? 'm-sm-3 text-center newbooklinks'
                : 'm-2 text-center oldbooklinks'
            }>
            {book.links.map((l) => (
              <ExternalLink
                key={l.url}
                href={l.url}
                className={
                  isFeatured
                    ? 'btnNoneLight px-2 mx-1 px-sm-3 mx-sm-2 mx-lg-3'
                    : 'btnDarkLight px-2 mx-1 mx-xxl-2'
                }>
                {l.label}
              </ExternalLink>
            ))}
          </p>
        ) : null}
      </section>
    </div>
  );
}
